"use client"

import { useMemo } from "react"

import { useQueryClient } from "@tanstack/react-query"

import type { Api } from "@/platform/api/api"
import { browserApi } from "@/platform/session/browser-api"
import { useViewer } from "@/platform/session/use-viewer"
import { ANONYMOUS_VIEWER } from "@/platform/session/viewer"

export const useApi = (): Api => {
  const queryClient = useQueryClient()
  const viewer = useViewer()
  return browserApi(queryClient, viewer ?? ANONYMOUS_VIEWER)
}

export const useGateway = <T>(factory: (api: Api) => T): T => {
  const api = useApi()
  return useMemo(() => factory(api), [factory, api])
}
